import { render, staticRenderFns } from "./HoverPopSummary.vue?vue&type=template&id=13d07b1f&scoped=true&"
import script from "./HoverPopSummary.vue?vue&type=script&lang=js&"
export * from "./HoverPopSummary.vue?vue&type=script&lang=js&"
import style0 from "./HoverPopSummary.vue?vue&type=style&index=0&id=13d07b1f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d07b1f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
